import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack, HowToReg, Visibility } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const EventNavigation: React.FC<{ slug: string; page: 'view' | 'rsvp' | 'edit'; rsvpClosed?: boolean }> = ({ slug, page, rsvpClosed = false }) => {
  const { session } = useAuth();
  // Always construct clean destinations: neither invitation queries nor edit
  // capabilities confer access on the next page or belong in navigation links.
  const destination = page === 'view' ? `/rsvp/events/${encodeURIComponent(slug)}` : `/view/events/${encodeURIComponent(slug)}`;
  return <Box component="nav" aria-label="Event navigation" sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5 }}>
    {page === 'view' && rsvpClosed
      ? <Button variant="contained" disabled startIcon={<HowToReg />}>RSVP closed</Button>
      : <Button component={RouterLink} to={destination} variant="contained" startIcon={page === 'view' ? <HowToReg /> : <Visibility />}>
        {page === 'view' ? 'RSVP' : 'View Event'}
      </Button>}
    {session?.can_manage && <Button component={RouterLink} to="/" variant="outlined" startIcon={<ArrowBack />}>Back to Events</Button>}
  </Box>;
};

export default EventNavigation;
